import { useCallback, useState } from 'react';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import InputAdornment from '@material-ui/core/InputAdornment';
import CircularProgress from '@material-ui/core/CircularProgress';
import Hidden from '@material-ui/core/Hidden';

import { Formik, Form, FormikHelpers, Field } from 'formik';
import { TextField } from 'formik-material-ui';
import JSCookies from 'js-cookie';
import * as Yup from 'yup';

import { AuthService } from '../../../services';
import { LockIcon } from '../../../assets/icons';
import useCommonStyles, { blueButtonProps } from '../../../styles/common';
import useStyles from '../styles';
import ErrorMessage from '../../../components/ErrorMessage';

interface ValuesModel {
  password: string;
  confirmPassword: string;
}

const Values: ValuesModel = {
  password: '',
  confirmPassword: '',
};

const ValidationSchema = Yup.object().shape({
  password: Yup.string().required('Senha é obrigatória'),
  confirmPassword: Yup.string().required('Confirmação de senha é obrigatória').oneOf([Yup.ref('password'), null], 'Senhas diferentes'),
});

const Security = () => {
  const classes = useStyles();
  const commonClasses = useCommonStyles();
  const [hasError, setHasError] = useState(false);
  const [hasSuccess, setHasSuccess] = useState(false);

  const handleFormik = useCallback(async (values: ValuesModel, helpers: FormikHelpers<ValuesModel>) => {
    const token = JSCookies.get('token');
    try {
      await AuthService.resetPassword(token, values.password, values.confirmPassword);
      setHasError(false);
      setHasSuccess(true);
    } catch (error) {
      console.log(error);
      setHasError(true);
      setHasSuccess(false);
    }
  }, []);

  const handleClose = useCallback(() => {
    setHasError(false);
    setHasSuccess(false);
  }, []);

  return (
    <Grid item md={9} lg={6}>

      <Formik initialValues={Values} onSubmit={handleFormik} validationSchema={ValidationSchema}>
        {({ isSubmitting, touched, errors }) => (
          <Form className={classes.form}>

            <Hidden smUp>
              <Typography variant='h2'>Segurança</Typography>
            </Hidden>

            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Field
                  name='password'
                  component={TextField}
                  type='password'
                  label='Senha'
                  size='small'
                  error={!!touched.password && Boolean(errors.password)}
                  helperText={!!touched.password && errors.password}
                  InputProps={{
                    className: commonClasses.inputs,
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <Field
                  name='confirmPassword'
                  component={TextField}
                  type='password'
                  label='Confirmar Senha'
                  size='small'
                  error={!!touched.confirmPassword && Boolean(errors.confirmPassword)}
                  helperText={!!touched.confirmPassword && errors.confirmPassword}
                  InputProps={{
                    'className': commonClasses.inputs,
                    endAdornment: (
                      <InputAdornment position='end'>
                        <LockIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <ErrorMessage
                  open={hasError || hasSuccess}
                  handleClose={handleClose}
                  title={hasError ? 'Erro' : 'Sucesso'}
                  severity={hasError ? 'error' : 'success'}
                  message={
                    hasError ? (
                      <>Erro ao alterar a senha. Favor tente novamente</>
                    ) : (
                      <>Senha alterada com sucesso</>
                    )
                  }
                />
              </Grid>
            </Grid>
            <Box marginTop={4}>
              <Button
                type='submit'
                startIcon={isSubmitting ? <CircularProgress size='1rem' /> : null}
                disabled={isSubmitting}
                className={commonClasses.blueButton}
                {...blueButtonProps}
              >
                Salvar Alterações
              </Button>
            </Box>
          </Form>
        )}
      </Formik>
    </Grid>
  );
};

export default Security;